module.exports = __webpack_public_path__ + "img/13.7c6b3b04.png";